module.exports = __webpack_public_path__ + "img/LUX.b95acc90.svg";